import { forwardRef, type IframeHTMLAttributes, type Ref } from "react";

/**
 * Props for `IFrame.Default` (currently a stub).
 *
 * Reserved for a future non-react-query variant.
 */
export type IFrameDefaultProps = IframeHTMLAttributes<HTMLIFrameElement>;

/**
 * **Stub component** – not implemented yet.
 *
 * Logs a console warning in development.
 */
export const IFrameDefault = forwardRef<HTMLIFrameElement, IFrameDefaultProps>(
  (_props, _ref: Ref<HTMLIFrameElement>) => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn(
        "[IFrame.Default] is not implemented yet. Use IFrame.Query for now.",
      );
    }
    return null;
  },
);

IFrameDefault.displayName = "IFrame.Default";
